// @flow
import React from 'react';
import { FormTitle, FormContent, FormFields, CloseForm } from './partials';
import { FieldForm } from './FieldForm';
import { getFormData } from './utils/utils';

type Props = {
  appId: string,
  formData: Object,
  field: Array<string>,
  onClose: Function
};

export class ServiceForm extends React.Component<Props> {
  render() {
    const data = getFormData(this.props.appId, this.props.formData.session.data);
    const adviserType = {
      'advisers-leads': 'Financiero',
      taxdown: 'Fiscal'
    };

    return (
      <FormContent>
        <CloseForm onClick={this.props.onClose} />
        <FormTitle>{`Respuestas al formulario para Asesoreamiento ${adviserType[this.props.appId]}`}</FormTitle>
        <FormFields>
          {data.map((item, index) => (
            <FieldForm key={index} field={item} />
          ))}
        </FormFields>
      </FormContent>
    );
  }
}
